class VideoComponent extends HTMLElement {
    connectedCallback() {
       this.videoBtn = this.querySelector('.tiktok-feed-item__play-button');
       this.videoEl = this.querySelector('video');

       if (this.videoBtn && this.videoEl) {
           this.videoBtn.addEventListener('click', this.toggleVideo.bind(this));
       }

       window.addEventListener('scroll', this.handleScroll.bind(this));

    }

    static stopAllVideos(excludeComponent) {
        const allVideoComponents = document.querySelectorAll('video-component');
        
        allVideoComponents.forEach(component => {
            if (component !== excludeComponent) {
                const videoEl = component.querySelector('video');
                const videoBtn = component.querySelector('.tiktok-feed-item__play-button');

                if (videoEl) {
                    videoEl.pause();
                }

                if (videoBtn) {
                    videoBtn.setAttribute('aria-pressed', 'false');
                }
            }
        });
    }

    toggleVideo(){
        const isPressed = this.videoBtn.getAttribute('aria-pressed') === 'true';

        if (isPressed) {
            this.videoEl.pause();
            this.videoBtn.setAttribute('aria-pressed', 'false');
        } else {
            VideoComponent.stopAllVideos(this);
            this.videoEl.play();
            this.videoBtn.setAttribute('aria-pressed', 'true');
        }
    }

    handleScroll() {
        const videoRect = this.getBoundingClientRect();
        const videoTop = videoRect.top;
        const videoBottom = videoRect.bottom;

        const isVideoVisible = videoTop < window.innerHeight && videoBottom > 0;

        if (!isVideoVisible) {
            this.videoEl.pause();
            this.videoBtn.setAttribute('aria-pressed', 'false')
        }
    }
}

customElements.define('video-component', VideoComponent);